import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { Box, Text, Input, Flex, Alert, AlertIcon } from '@chakra-ui/react'
import Axios from '../../../Axios'
import { Button, get, money, useBillingAction } from './shared'

export default function Reconstruction({
  month,
  state,
  canWrite,
  hasResponses
}) {
  const { busy, action } = useBillingAction()
  const [preview, setPreview] = useState(null)
  const [reason, setReason] = useState('')
  const versions = useQuery(
    ['billing', 'reconstructions', month],
    () => get('reconstructions', { period: month }),
    { enabled: hasResponses && !state?.batch, retry: false }
  )
  if (!hasResponses || state?.batch) return null
  return (
    <Box my={5} p={4} borderWidth="1px" borderRadius={8}>
      <Text fontWeight="semibold" color="green.500">
        Esperado reconstruido
      </Text>
      <Text fontSize="sm" my={2}>
        Este mes no tiene una nómina enviada. El esperado se calcula con las
        reglas vigentes del mes y la clasificación disponible. Los grupos
        deducidos del cobro quedan como estimados; los cobros reales se
        conservan.
      </Text>
      {versions.data?.map((v) => (
        <Text key={v._id} fontSize="xs" color="gray.600" mb={2}>
          Versión {v.version} ·{' '}
          {new Date(v.createdAt).toLocaleString('es-CL', {
            timeZone: 'America/Santiago'
          })}{' '}
          · {v.reason}
        </Text>
      ))}
      {canWrite && !state?.closedAt && (
        <>
          <Button
            size="sm"
            isLoading={busy}
            onClick={() =>
              action(async () =>
                setPreview(
                  await get('reconstructions/preview', { period: month })
                )
              )
            }
          >
            Revisar reconstrucción
          </Button>
          {preview && (
            <>
              <Alert status="warning" my={3}>
                <AlertIcon />
                <Text fontSize="sm">
                  Nuevo esperado conocido: {money(preview.summary.total)}.{' '}
                  {preview.summary.confirmedCount} confirmados,{' '}
                  {preview.summary.estimatedCount} estimados y{' '}
                  {preview.summary.unresolvedCount} por determinar. Publicar
                  crea una nueva versión; las anteriores se conservan.
                </Text>
              </Alert>
              <Flex gap={3} wrap="wrap">
                <Input
                  flex="1"
                  minW="200px"
                  aria-label="Motivo de reconstrucción"
                  placeholder="Motivo de reconstrucción (mínimo 10 caracteres)"
                  value={reason}
                  maxLength={500}
                  onChange={(e) => setReason(e.target.value)}
                />
                <Button
                  isLoading={busy}
                  isDisabled={reason.trim().length < 10}
                  onClick={() =>
                    action(async () => {
                      await Axios.post(
                        `/billing/periods/${month}/reconstruct`,
                        { reason }
                      )
                      setPreview(null)
                      setReason('')
                    }, 'Esperado reconstruido')
                  }
                >
                  Publicar reconstrucción
                </Button>
              </Flex>
            </>
          )}
        </>
      )}
    </Box>
  )
}
